import { Routes } from '@angular/router';
import { AddCategoryComponent } from './add-category/add-category.component';
import { CategoriesComponent } from './categories/categories.component';

export const CategoryRoutingModule: Routes = [
	{ path: 'categories', component: CategoriesComponent },
	{ path: 'add-category', component: AddCategoryComponent },
];
